import { createContext, useContext } from 'react';
var NavBarContext =
/*#__PURE__*/
createContext({
  isMobile: false
});

var useNavBarContext = function useNavBarContext() {
  return useContext(NavBarContext);
};

var NavBarProvider = NavBarContext.Provider;
export { NavBarContext, NavBarProvider, useNavBarContext };